import { createContext } from 'react';

const LocatorContext = createContext();

export default LocatorContext;
